<template>
  <div id="chart_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        客服信息
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="chart_win">
        <div class="content1" ref="scrool">
          <div class="clearfix" v-for="(item,index) in client_msg" :key="index">
            <div :class="item.type == 'client' ?'client' : 'bioflin'">{{item.msg}}</div>
          </div>
        </div>
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6}"
            placeholder="请输入内容"
            v-model="textarea1"
            @keyup.enter.native="send()"
          ></el-input>
          <div class="clearfix">
            <el-button @click="send" style="float:right">发送</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      websock: null,
      textarea1: "",
      serve: this.$store.state.serve,
      // token: this.$cookies.get("token"),
      // username: this.$cookies.get("username"),
      fd: this.$route.params.fd,
      client_msg: []
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "客服信息";
    this.geting();
    this.initWebSocket();
  },
  mounted() {
    this.btn();
    //默认在最底部
  },
  updated() {
    this.btn();
  },
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  },
  watch: {},
  methods: {
    initWebSocket() {
      //初始化weosocket
      const wsuri = "ws://111.231.166.243:9502";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    kepdawn() {
      const _this = this;
      document.onkeydown = function(e) {
        var key = window.event.keyCode;
        if (key == 13) {
          _this.send();
        }
      };
    },
    websocketonopen(res) {
      //连接建立之后执行send方法发送数据
      let actions = { fd: this.fd, msg: "start", type: "server" };
      this.websocketsend(JSON.stringify(actions));
      console.log("链接成功");
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      console.log(redata);
      this.client_msg.push(redata);
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
      this.client_msg.push(JSON.parse(Data));
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
    geting() {
      this.axios
        .get("http://111.231.166.243:9501/service_list?type=1")
        .then(res => {
          console.log(res);
          let msg = res.data;
          for (var i in msg) {
            if (msg[i].fd == this.fd) {
              this.client_msg = msg[i].msg;
            }
          }
        });
    },
    btn() {
      this.$refs.scrool.scrollTop = this.$refs.scrool.scrollHeight;
    },
    sss(str) {
      //除去空格和回车
      var reg = /^(<[^><]+>|\s|&nbsp)+$/;
      return reg.test(str);
    },
    send() {
      if (this.sss(this.textarea1)) {
        this.textarea1 = ''
      } else if (this.textarea1 != "") {
        let actions = { fd: this.fd, msg: this.textarea1, type: "server" };
        this.websocketsend(JSON.stringify(actions));
        this.textarea1 = "";
        //发送之后在底部
        this.btn();
      }
    }
  }
};
</script>
<style lang="scss">
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
#chart_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .box {
    /* width: 1056px; */
    /* margin: 0 auto; */
    width: 55%;
    margin: 0 auto;
  }
  .chart_win {
    background: #fff;
    width: 100%;
    /* .title {
      height: 60px;
      width: 100%;
      border: 1px solid #ddd;
      line-height: 60px;
      text-align: center;
    } */
    .content1 {
      border: 1px solid #ddd;

      height: 500px;
      overflow-y: scroll;
      .client {
        border: 1px solid #ededed;
        padding: 15px 10px;
        border-radius: 6px;
        background: #f5f5f5;
        /* display: inline-block; */
        float: left;
        margin-bottom: 10px;
        max-width: 40%;
      }
      .bioflin {
        max-width: 40%;
        float: right;
        margin-bottom: 10px;
        display: inline-block;
        border: 1px solid #ededed;
        padding: 15px 10px;
        border-radius: 6px;
        background: #9eea6a;
      }
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .type_box {
    padding-right: 20px;
    line-height: 46px;
  }

  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
}
</style>